import React from 'react'
import { shallow } from 'enzyme'
import { PodsLayout } from '../PodsLayout'
import SubNav from '../../common/SubNav'
import Loader from '../../common/Loader'
import Error from '../../common/Error'
import BlueLoadingButton from '../../common/BlueLoadingButton'

describe('<PodsLayout />', () => {
  let wrapper, props, instance
  beforeEach(() => {
    props = {
      data: {
        administrators: [
          { name: 'test admin 1', rid: 1 }
        ],
        pods: [
          { name: 'test pod 1', rid: 1 }
        ],
        error: null,
        loading: false
      }
    }
    wrapper = shallow(<PodsLayout {...props} />)
    instance = wrapper.instance()
  })
  describe('#onCreatePodToggle', () => {
    describe('when isCreatePodModalOpen is true', () => {
      beforeEach(() => {
        wrapper.setState({ isCreatePodModalOpen: true, currentEditedPod: 1 })
      })
      it('should change isCreatePodModalOpen to false', () => {
        instance.onCreatePodToggle()
        expect(wrapper.state('isCreatePodModalOpen')).toBe(false)
      })
      it('should set currentEditedPod to null', () => {
        instance.onCreatePodToggle()
        expect(wrapper.state('currentEditedPod')).toBeNull()
      })
    })
    describe('when isCreatePodModalOpen is false', () => {
      beforeEach(() => {
        wrapper.setState({ isCreatePodModalOpen: false })
      })
      it('should change isCreatePodModalOpen to true', () => {
        instance.onCreatePodToggle()
        expect(wrapper.state('isCreatePodModalOpen')).toBe(true)
      })
    })
  })
  describe('#onPodEdit', () => {
    beforeEach(() => {

    })
    it('should update currentEditedPod with the pod that matches the provided rid', () => {
      const rid = 1
      instance.onPodEdit({ rid })
      const editedPod = props.data.pods.find(pod => pod.rid === rid)
      expect(wrapper.state('currentEditedPod')).toBe(editedPod)
    })
    it('should call onCreatePodToggle', () => {
      const onCreatePodToggleMock = jest.fn()
      instance.onCreatePodToggle = onCreatePodToggleMock
      instance.onPodEdit({ rid: 1 })
      expect(onCreatePodToggleMock).toHaveBeenCalled()
    })
  })
  describe('#render', () => {
    it('should return something', () => {
      expect(instance.render()).toBeTruthy()
    })
    describe('when loading is true', () => {
      beforeEach(() => {
        wrapper.setProps({ data: { ...props.data, loading: true } })
      })
      it('should render a <Loader />', () => {
        expect(wrapper.find(Loader)).toHaveLength(1)
      })
      it('should render a <SubNav />', () => {
        expect(wrapper.find(SubNav)).toHaveLength(1)
      })
    })
    describe('when loading is false and error is true', () => {
      beforeEach(() => {
        wrapper.setProps({ data: { ...props.data, loading: false, error: {} } })
      })
      it('should render an error', () => {
        expect(wrapper.find(Error)).toHaveLength(1)
      })
    })
    describe('when loading and error props are falsy', () => {
      beforeEach(() => {
        wrapper.setProps({ data: { ...props.data, loading: false, error: null } })
      })
      it('should render a <SubNav />', () => {
        expect(wrapper.find(SubNav)).toHaveLength(1)
      })
      it('should render a <BlueLoadingButton />', () => {
        expect(wrapper.find(BlueLoadingButton)).toHaveLength(1)
      })
    })
  })
})
